import { color, media, spacing } from '@gyym/ui'
import styled from 'styled-components'

interface BaseContainerProps {
  maxWidth: number
  paddingX: number | [number, number]
}

interface ContentBlockProps extends BaseContainerProps {
  hideFromTablet: boolean
  grayBackground?: boolean
}

export const BreadcrumbsContainer = styled.div<ContentBlockProps>`
  max-width: ${({ maxWidth }) => maxWidth}px;
  width: 100%;
  margin: 0 auto;
  padding: ${({ paddingX }) =>
    spacing(4, Array.isArray(paddingX) ? paddingX[0] : paddingX)};
  display: ${({ hideFromTablet }) => (hideFromTablet ? 'none' : 'block')};
  background: ${({ grayBackground }) => grayBackground && color('gray.06')};

  ${media.pc} {
    display: block;
    padding: ${({ paddingX }) =>
      spacing(4, Array.isArray(paddingX) ? paddingX[1] : paddingX)};
  }
`

export const HeadingContainer = styled.div<ContentBlockProps>`
  max-width: ${({ maxWidth }) => maxWidth}px;
  width: 100%;
  margin: 0 auto;
  align-items: center;
  padding: ${({ paddingX }) =>
    spacing(0, Array.isArray(paddingX) ? paddingX[0] : paddingX)};
  display: ${({ hideFromTablet }) => (hideFromTablet ? 'none' : 'flex')};
  flex-wrap: wrap;
  gap: 0 ${spacing(4)};

  ${media.pc} {
    display: flex;
    padding: ${({ paddingX }) =>
      spacing(0, Array.isArray(paddingX) ? paddingX[1] : paddingX)};
  }
`

export const CoverContainer = styled.div`
  height: 230px;
  width: 100%;
  display: block;
  position: relative;

  ${media.tablet} {
    height: 340px;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 10;
    // Dotted image overlay
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAAXNSR0IArs4c6QAAABtJREFUGFdjZGBI9mVgmLuZgYGBgRFEwAAKBwBCNQIEt9nIVwAAAABJRU5ErkJggg==)
      repeat;
  }
`

interface ContainerProps extends BaseContainerProps {
  hasCover?: boolean
}

export const Container = styled.div<ContainerProps>`
  max-width: ${({ maxWidth }) => maxWidth}px;
  width: 100%;
  margin: ${({ hasCover }) => (hasCover ? spacing(6) : 0)} auto 0;
  padding: ${({ paddingX }) =>
    spacing(0, Array.isArray(paddingX) ? paddingX[0] : paddingX, 10)};

  ${media.pc} {
    margin: ${({ hasCover }) => (hasCover ? spacing(10) : 0)} auto 0;
    padding: ${({ paddingX }) =>
      spacing(0, Array.isArray(paddingX) ? paddingX[1] : paddingX, 28)};
  }
`

export const Content = styled.div<{ hasHeading: boolean }>`
  margin-top: ${({ hasHeading }) => (hasHeading ? spacing(6) : 0)};
`
